import React, { FC } from 'react';

import { useParams } from "react-router-dom";
import { useGetProductQuery } from '../components/productPage/ApiRequests';
import { BuyPanel } from '../components/productPage/BuyPanel';
import { CommentsPanel } from '../components/productPage/Comments';
import { ScorePanel } from '../components/productPage/ScorePanel';
import { ShowSpecifications } from '../components/productPage/ShowSpecifications';
import { Description } from '../components/productPage/Types';
import { StarScore } from '../components/StarScore';
import styles from './Product.module.css';

const ProductDescriptions: FC<{ descriptions: Description[] }> = (props) => {
  return (
    <div>
      {
        props.descriptions.map(desc => {
          return (
            <div key={desc.id} className={styles.description} >
              <img src={desc.imageUrl} alt="icon"></img>
              <p>{desc.description}</p>
            </div >
          );
        })
      }
    </div>
  );
}

export const ProductPage = () => {
  const params = useParams();

  const productQuery = useGetProductQuery(Number(params[0]));

  if (productQuery.isLoading) {
    return <span>Loading...</span>
  }

  if (productQuery.isError) {
    return <span>Error: {productQuery.error.message}</span>
  }

  const product = productQuery.data;

  const votesCount = Object.values(product.scores).reduce((prev, curr) => prev + curr, 0);

  return (
    <div>
      <div className={styles.header}>
        <img src={product.imageSrc} alt="product" />
        <div className={styles.asidePanel}>
          <div className={styles.asideHeader}>
            <h2>{product.name}</h2>
            <div className={styles.scores}>
              <StarScore score={product.scoreValue} starCount={10} />
              <span>({votesCount} opinions)</span>
            </div>
          </div>
          <div className={styles.asideContent}>
            <div className={styles.specificationsMain}>
              <ShowSpecifications specifications={product.specification} isMain={true} className={styles.specificationsMain} />
            </div>
            <BuyPanel purchasedProduct={product} />
          </div>
        </div>
      </div >
      <ProductDescriptions descriptions={product.descriptions} />
      <h2>Specification</h2>
      <div className={styles.specificationsOther}>
        <ShowSpecifications specifications={product.specification} isMain={false} className={styles.specificationsOther} />
      </div>
      <div className={styles.comments}>
        <hr />
        <h2>Opinions</h2>
        <ScorePanel productScore={product.scoreValue} votesCount={votesCount} scores={product.scores} productName={product.name} />
        <hr />
        <CommentsPanel productId={Number(params[0])} />
      </div>
      <hr />
    </div >
  );
}
